var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66675 10.0833V15.5833M13.3334 10.0833V15.5833M4.16675 6.41667H18.8334M17.9167 6.41667L17.122 17.5468C17.0891 18.0094 16.8821 18.4422 16.5428 18.7583C16.2034 19.0743 15.757 19.25 15.2932 19.25H7.70691C7.24321 19.25 6.79673 19.0743 6.45739 18.7583C6.11806 18.4422 5.91109 18.0094 5.87816 17.5468L5.08341 6.41667H17.9167ZM14.2501 6.41667V3.66667C14.2501 3.42355 14.1535 3.19039 13.9816 3.01849C13.8097 2.84658 13.5765 2.75 13.3334 2.75H9.66675C9.42363 2.75 9.19048 2.84658 9.01857 3.01849C8.84666 3.19039 8.75008 3.42355 8.75008 3.66667V6.41667H14.2501Z",
    stroke: "#FF384C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrash);
export default __webpack_public_path__ + "static/media/ic_trash.6366c28e83db978a5bbd6fa0da8fb5af.svg";
export { ForwardRef as ReactComponent };